import * as React from 'react';

export const useIsOverflow = () => {
    const [isOverflow, setIsOverflow] = React.useState<null | boolean | undefined>(null);

    React.useEffect(() => {
        const hasOverflow = window.innerHeight < document.body.clientHeight;
        setIsOverflow(hasOverflow);
    });

    return isOverflow;
};
